import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, Form, Input } from "antd";
import { useDispatch } from "react-redux";
import { editProfessionalProfile } from "redux/actions";
import { useForm } from "antd/lib/form/Form";

const formItemLayout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
};

function EditProfessionalProfile({ data, closeModel }) {
  const dispatch = useDispatch();
  const [form] = useForm();

  const onFinish = (values) => {
    dispatch(
      editProfessionalProfile({ ...values, professionalProfileId: data._id })
    );
    closeModel();
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <Form
      form={form}
      className="edit-customer-form"
      name="basic"
      layout="vertical"
      {...formItemLayout}
      initialValues={{
        professionalProfileName: data.professionalProfileName,
        professionalProfileName_es: data.professionalProfileName_es,
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Form.Item
        name="professionalProfileName"
        label="Name"
        rules={[
          { required: true, whitespace: true, message: "Name is required" },
        ]}
      >
        <Input placeholder="Professional Profile Name" />
      </Form.Item>
      <Form.Item
        label="Nombre"
        name="professionalProfileName_es"
        rules={[
          {
            required: true,
            whitespace: true,
            message: "El nombre es necesario",
          },
        ]}
      >
        <Input
          name="professionalProfileName"
          placeholder="Nombre del perfil profesional"
        />
      </Form.Item>

      <Form.Item
        wrapperCol={{
          span: 12,
          offset: 10,
        }}
      >
        <Button type="primary" htmlType="submit">
          Save
        </Button>
      </Form.Item>
    </Form>
  );
}

export default EditProfessionalProfile;

EditProfessionalProfile.propTypes = {
  data: PropTypes.object,
  closeModel: PropTypes.func,
};
